/**
 * Shared contract for window `open-document` CustomEvents.
 *
 * Callers historically used either `filePath` or `documentId` (UUID). Listeners
 * must accept both — soul-proposal / quiz / flow cards dispatch `documentId` only.
 */
import type { OpenIntentClickEvent } from '@/lib/open-intent'

export type OpenDocumentEventDetail = {
  /** Document UUID (preferred when known). */
  documentId?: string
  /** Storage path or UUID-as-path (legacy field name). */
  filePath?: string
  openInNewTab?: boolean
  clickEvent?: OpenIntentClickEvent
  searchQuery?: string
}

/** Resolve the id/path passed to handleDocumentClick from an open-document detail. */
export function resolveOpenDocumentTarget(
  detail: OpenDocumentEventDetail | null | undefined,
): string {
  if (!detail || typeof detail !== 'object') return ''
  const documentId =
    typeof detail.documentId === 'string' ? detail.documentId.trim() : ''
  if (documentId) return documentId
  const filePath = typeof detail.filePath === 'string' ? detail.filePath.trim() : ''
  return filePath
}
